import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { Package } from "lucide-react";

const c = {
  greenMd: "#2D6B45",
  ink: "#0F1F17",
  muted: "#6B7D74",
  surface: "#F4F6F5",
  border: "rgba(28,74,46,0.1)",
};

interface PedidoItem {
  pedido_items_id: number;
  nombre: string;
  cantidad: number;
}

interface Props {
  pedidoViewID: number;
}

const PedidoItems = ({ pedidoViewID }: Props) => {
  const [pedidoItems, setPedidoItems] = useState<PedidoItem[]>([]);

  const getPedidoItems = useCallback(async (id: number) => {
    if (!id) return;
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/pedidos/items/${id}`,
        {
          headers: {
            "auth-token": `${sessionStorage.getItem("token")}`,
          },
        }
      );
      const data = response.data;
      setPedidoItems(Array.isArray(data) ? data : []);
    } catch {
      setPedidoItems([]);
    }
  }, []);

  useEffect(() => {
    getPedidoItems(pedidoViewID);
  }, [pedidoViewID, getPedidoItems]);

  if (pedidoItems.length === 0) {
    return (
      <p className="px-1 py-3 text-center text-sm" style={{ color: c.muted }}>
        No hay artículos en este pedido.
      </p>
    );
  }

  return (
    <div className="flex flex-col gap-0">
      {pedidoItems.map((item, i) => (
        <div
          key={item.pedido_items_id}
          className={`flex items-start gap-2.5 py-2.5 ${
            i > 0 ? "border-t border-[rgba(28,74,46,0.1)]" : ""
          }`}
        >
          <div
            className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg"
            style={{ background: c.surface, color: c.greenMd }}
          >
            <Package className="h-4 w-4" strokeWidth={1.75} />
          </div>
          <div className="min-w-0 flex-1">
            <p
              className="text-[0.55rem] font-semibold uppercase tracking-wider"
              style={{ color: c.greenMd }}
            >
              Premio
            </p>
            <p
              className="mt-0.5 text-sm font-bold leading-snug"
              style={{ color: c.ink }}
            >
              {item.nombre}
            </p>
            <p
              className="mt-0.5 text-xs font-medium"
              style={{ color: c.muted }}
            >
              Cantidad: {item.cantidad}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PedidoItems;
